import React, { FunctionComponent, MouseEventHandler, ReactElement } from 'react'
import style from './cartbox-button.css'

export type Props = {
    onClick: MouseEventHandler
    disabled?: boolean
    icon: ReactElement
    label: string
    dataTestId?: string
}

const CartboxButton: FunctionComponent<Props> = (props) => {
    const {
        onClick,
        disabled,
        icon,
        label,
        dataTestId,
    } = props

    return (
        <button
            onClick={onClick}
            className={style.button}
            disabled={disabled}
            type="button"
            data-testid={dataTestId}
        >
            <span className={style.iconWrapper}>{icon}</span>
            <span>{label}</span>
        </button>
    )
}

export default CartboxButton
